import { render, staticRenderFns } from "./bRemSetting.vue?vue&type=template&id=1996a059&scoped=true"
import script from "./bRemSetting.vue?vue&type=script&lang=js"
export * from "./bRemSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996a059",
  null
  
)

export default component.exports